<template>
  <div class="find-pwd">
    <h1>忘记密码</h1>
    <h2>Forget the password</h2>
    <div class="find-pwd-form form-wrap">
      <label>请输入您的手机号</label>
      <div class="input-wrap">
        <input type="text" v-model="tel" v-focus="true">
      </div>
      <button class="login-btn" @click="nextStep">下一步</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'signIn',
  data() {
    return {
      tel: ''
    }
  },
  methods: {
    nextStep() {
      this.$store
        .dispatch('FetchForgetCode', this.tel)
        .then(() => {
          this.$message({
            message: '短信发送成功',
            type: 'success'
          })
          this.$router.push({
            path: '/login/find-pwd-next'
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
.find-pwd {
  text-align: center;
  color: #2c5ac8;
  h2 {
    margin-bottom: 70px;
  }
  label {
    font-size: 16px;
    font-weight: 600;
    color: #b9bdc7;
    line-height: 22px;
    display: block;
    text-align: left;
  }
}
</style>
